import { OverrideEnumArray } from '../../../../decorators';
import { CaptchaAction } from '..';

export class CaptchaVersionConfig {
    enabled = false;
    siteKey = '';
    @OverrideEnumArray(CaptchaAction)
    allowedActions;
}
